import { TokenInfo } from '@/models/TokenInfo';

import UploadDonationsRouter from '../views/uploadDonations/router';


export class ZgRouterFactory {
    public static GetCorrectRouterByToken(tokenInfo: TokenInfo) {
        if (tokenInfo.isTokenUploadDonations()) {
            return UploadDonationsRouter.vueRouter;
        }
    }
}
